import React, { useState } from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';

import { SVGIcon } from 'common/components';
import { useClassName } from 'common/hooks';
import { ControlledInputContainer } from 'public/components/ControlledInputContainer';
import { Calendar } from 'public/components/Calendar';

import './modular-date-picker.less';

const ModularDatePicker = ({
  date,
  setDate,
  error,
  onBlur,
  placeholder,
  readOnly,
  pastOnly,
}) => {
  const classNames = useClassName('ModularDatePicker');
  const [isOpen, setOpen] = useState(false);

  return (
    <ControlledInputContainer
      addonLeft={<SVGIcon name="date" className={classNames('addon-left')} />}
      input={
        <input
          readOnly
          data-locked={readOnly || undefined}
          placeholder={placeholder}
          value={
            date
              ? DateTime.fromISO(date).toLocaleString(DateTime.DATE_FULL)
              : ''
          }
        />
      }
      addonRight={
        <SVGIcon name="angle-down" className={classNames('addon-right')} />
      }
      hasFocus={isOpen}
      error={error}
      onClick={() => !readOnly && setOpen(true)}
      trigger={
        <Calendar
          initialDate={date}
          open={isOpen}
          pastOnly={pastOnly}
          updateSelectedDate={(date) => {
            setOpen(false);
            const isoDate = DateTime.fromJSDate(date).toISODate();
            setDate(isoDate);
            onBlur({ value: isoDate });
          }}
          closeModal={() => {
            setOpen(false);
            onBlur({});
          }}
          openModal={() => {
            if (!readOnly) setOpen(true);
          }}
        />
      }
    />
  );
};

ModularDatePicker.propTypes = {
  date: PropTypes.string,
  setDate: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  pastOnly: PropTypes.bool,
};

ModularDatePicker.defaultProps = {
  onBlur: () => {},
};

export default ModularDatePicker;
